import { memo } from "react";
import brandLogo from "../../../../../../Common/assets/logo/wl-woodmark-logo-rev.svg";
import brandmarkLogo from "../../../../../../Common/assets/logo/wl-brandmark-primary-rev.svg";

import s from "./LoginOTPLogoRow.module.scss";

const LoginOTPLogoRow: React.FC = (): JSX.Element => {
  return (
    <div className={s.logoRow}>
      <img className={s.logoBrandmark} src={brandmarkLogo} alt="" loading="eager" decoding="async" />
      <img className={s.logoWoodmark} src={brandLogo} alt="" loading="eager" decoding="async" />
    </div>
  );
};

export default memo(LoginOTPLogoRow);
